import React from 'react';
import {
    PercentageOutlined,
    ClockCircleOutlined,
    UnorderedListOutlined,
} from '@ant-design/icons';
import {
    SmartDefaultsRoot,
    SmartDefaultsHeader,
    SmartDefaultsStatus,
    SmartDefaultsStatusDot,
    SmartDefaultsTitle,
    SmartDefaultsDescription,
    SmartDefaultsChips,
    SmartDefaultsChip,
    SmartDefaultsChipLabel,
    SmartDefaultsChipValue,
} from './smartDefaults.style';

const METRIC_CHIPS = [
    {
        key: 'cogs',
        icon: PercentageOutlined,
        label: 'COGS',
        format: (d) => `${d.cogsPercentOfPrice}% of price`,
    },
    {
        key: 'replenish',
        icon: ClockCircleOutlined,
        label: 'Replenish',
        format: (d) => `${d.replenishmentDays} days`,
    },
    {
        key: 'unsellable',
        icon: UnorderedListOutlined,
        label: 'Unsellable',
        format: (d) => `${d.unsellableReturnsPercent}%`,
    },
    {
        key: 'taxCogs',
        icon: PercentageOutlined,
        label: 'Tax on COGS',
        format: (d) => `${d.taxPaidOnCogsPercent}%`,
    },
    {
        key: 'taxCollected',
        icon: PercentageOutlined,
        label: 'Tax collected',
        format: (d) => `${d.taxCollectedOnSalesPercent}%`,
    },
];

const SmartDefaultsBanner = ({ defaults, onEditClick, canEdit = true }) => (
    <SmartDefaultsRoot className="smart-defaults-banner">
        <SmartDefaultsHeader>
            <div>
                <SmartDefaultsStatus>
                    <SmartDefaultsStatusDot aria-hidden />
                    Smart defaults · On
                </SmartDefaultsStatus>
                <SmartDefaultsTitle>Your numbers work out of the box</SmartDefaultsTitle>
                <SmartDefaultsDescription>
                    We&apos;ve pre-filled COGS, taxes, returns &amp; lead time so every insight lights up from day one.
                    Fine-tune anytime - these are estimates, your real figures make them exact.
                </SmartDefaultsDescription>
            </div>
            <button
                type="button"
                className="btn btn-sm btn-light-danger fs-7 fw-bold border border-danger border-opacity-25 flex-shrink-0"
                onClick={onEditClick}
                disabled={!canEdit}
                aria-label="Edit smart defaults"
            >
                <i className="bi bi-pencil me-1" />
                Edit Defaults
            </button>
        </SmartDefaultsHeader>

        <SmartDefaultsChips>
            {METRIC_CHIPS.map(({ key, icon: Icon, label, format }) => (
                <SmartDefaultsChip key={key}>
                    <Icon style={{ fontSize: 13, color: 'var(--app-text-muted)' }} />
                    <SmartDefaultsChipLabel>{label}</SmartDefaultsChipLabel>
                    <SmartDefaultsChipValue>{format(defaults)}</SmartDefaultsChipValue>
                </SmartDefaultsChip>
            ))}
        </SmartDefaultsChips>
    </SmartDefaultsRoot>
);

export default SmartDefaultsBanner;
